import { useState } from "react";
import {
  GridExpandMoreIcon,
  GridSlotsComponentsProps,
} from "@mui/x-data-grid-pro";
import { Box, Button, Collapse, Stack } from "@mui/material";
import __ from "src/utils/Translations";
import { PendingBenefitsFilters } from "src/Pages/Company/Pending/PendingBenefits/Filters/PendingBenefitsFilters";
import { MassActionAccept } from "./MassActionAccept";
import { MassActionDecline } from "./MassActionDecline";
import { MassActionsMenu } from "./MassActionsMenu";

export const PendingBenefitsToolbar = (
  props: NonNullable<GridSlotsComponentsProps["toolbar"]>
) => {
  const { filters = {}, setFilters, refetch } = props;
  const [filtersOpen, setFiltersOpen] = useState<boolean>(
    Object.values(filters).length > 0
  );

  return (
    <Stack sx={{ gap: 1, flex: 1 }} role="toolbar">
      <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
        <Button
          size="small"
          variant="outlined"
          endIcon={<GridExpandMoreIcon />}
          sx={{
            "& .MuiButton-endIcon": {
              transform: filtersOpen ? "rotate(180deg)" : null,
            },
          }}
          onClick={() => setFiltersOpen((prev) => !prev)}
        >
          {__("Filtry")}
        </Button>
        <Box sx={{ flex: 1 }} />
        <MassActionAccept />
        <MassActionDecline />
        <MassActionsMenu />
      </Stack>
      <Collapse in={filtersOpen}>
        <PendingBenefitsFilters
          filters={filters}
          setFilters={setFilters}
          refetch={refetch}
        />
      </Collapse>
    </Stack>
  );
};
